const MASK_IMAGES=[
    process.env.PUBLIC_URL + '/assets/mask_images/13.png',
    process.env.PUBLIC_URL + '/assets/mask_images/14.png',
    process.env.PUBLIC_URL + '/assets/mask_images/15.png',
    process.env.PUBLIC_URL + '/assets/mask_images/16.png',
]

export default MASK_IMAGES;